import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import UserProfileDropdown from './UserProfileDropdown';
import { CreditsDisplay } from './CreditsDisplay';

interface AppNavigationProps {
  pageTitle?: string;
  onNewProject?: () => void;
  creditsRefreshTrigger?: number;
}

const AppNavigation: React.FC<AppNavigationProps> = ({ pageTitle, onNewProject, creditsRefreshTrigger }) => {
  const { currentUser, logout } = useAuth();

  return (
    <nav className="app-nav">
      {pageTitle && <h1 className="page-title">{pageTitle}</h1>}
      <div className="app-nav-actions">
        {onNewProject && (
          <button className="new-project-btn" onClick={onNewProject}>
            + New Project
          </button>
        )}
        {currentUser && <CreditsDisplay refreshTrigger={creditsRefreshTrigger} />}
        {currentUser && (
          <UserProfileDropdown currentUser={currentUser} onLogout={logout} />
        )}
      </div>
    </nav>
  );
};

export default AppNavigation; 